import React, {useContext, useEffect, useState} from "react";
import $ from "jquery";
import OptionNbItems from "../overbox/option/OptionNbItems";
import InputCheckbox from "../form/input/InputCheckbox";
import SortingArrowIcon from "../icons/SortingArrowIcon";
import Line from "./Line";
import LoaderCircle from "../loader/LoaderCircle";
import LeftArrow from "../icons/LeftArrow";
import RightArrow from "../icons/RightArrow";
import FiltersIcon from "../icons/FiltersIcon";
import CancelIcon from "../icons/CancelIcon";
import ListingContext from "../../context/ListingContext";
import stringTools from "../../class/tool/StringTools";

const Table = props => {
    const { item, titleNbItems, emptyList, model, list, loading, priceable, priceableValue, storeableValue, priceableChange, checkable, openable, listChecked, updatePageSelect, pagination, loadingPagePrev, loadingPageNext, showOptionNbItems, sortingParam, sortingDirection, noBorder, handleChangePerPage, handleCheckAll, handleSort, handleCheckLine, handleShowOptionNbItems, noMarginTopWrapList } = props
    const { filters, filterValues, validFilters, openFilters } = useContext(ListingContext);
    const [ values, setValues ] = useState({});
    const [ matchesMaxWidth1250, setMatchesMaxWidth1250 ] = useState(window.matchMedia('(max-width: 1250px)').matches);
    const [ matchesMaxWidth1100, setMatchesMaxWidth1100 ] = useState(window.matchMedia('(max-width: 1100px)').matches);
    const [ matchesMaxWidth940, setMatchesMaxWidth940 ] = useState(window.matchMedia('(max-width: 940px)').matches);

    const calcColspan = () => {
        let count = 0

        if (checkable) count++
        if (openable) count++

        count += model.length

        return count
    }
    const hasUrl = direction => {
        if(direction === "left")
            return pagination.prev_page_url !== null
        else
            return pagination.next_page_url !== null
    }
    const buildButtonArrow = direction => {
        if (pagination !== null && hasUrl(direction)) {
            return <button className="buttonArrow" onClick={() => { updatePageSelect(direction === "left" ? pagination.current_page - 1 : pagination.current_page + 1) }}>
                {
                    ((loadingPagePrev && direction === "left") || (loadingPageNext && direction === "right"))
                        ? <LoaderCircle display="loader loaderButtonArrow" strokeWidth="10" />
                        : (
                            direction === "left"
                                ? <LeftArrow />
                                : <RightArrow />
                        )
                }
            </button>
        }
        else {
            return <button className="buttonArrow disabled">
                {
                    direction === "left"
                        ? <LeftArrow />
                        : <RightArrow />
                }
            </button>
        }
    }
    const buildNbItems = () => {
        if (pagination !== null)
            return (pagination.from !== null ? pagination.from : 0) + " - " + (pagination.to !== null ? pagination.to : 0) + " sur " + pagination.total

        return "";
    }
    const buildThs = (column, index) => {
        let pricelist = null

        if (priceable !== null && priceableValue > -1 && ["price", "vat"].includes(column.type))
            pricelist = priceable.find(_ => _.id === priceableValue).object

        return <th key={index}
                   className={column.class + ((sortingParam !== "" && sortingParam === column.sortingParam) ? (" sorted " + sortingDirection) : "") + (column.sortingParam === null ? " unsortable" : "")}
                   style={
                        pricelist !== null
                            ? {
                               backgroundColor: pricelist.color + "22",
                               color: pricelist.color
                            }
                            : {}
                   }>
            <span onClick={(column.sortingParam !== "" && column.sortingParam !== null) ? () => { handleSort(column.sortingParam) } : null}>{column.title}</span>
            <SortingArrowIcon/>
        </th>
    }
    const initMaxHeightTableBody = () => {
        let maxHeight = $(".main.account").height()

        maxHeight -= $(".toolsBar").height()
        maxHeight -= $(".wrapList .pagination").height()
        maxHeight -= $(".wrapList .list thead").height()

        $("tbody.scrollable").css("maxHeight", maxHeight + "px")
    }
    const buildPriceableFilter = () => {
        let indexVat = model.findIndex(_ => _.type === "vat")
        let pricelist = null;
        let spanPrice = 0;
        let spanPricelistFilter = indexVat > -1 ? 2 : 1;

        if (priceable !== null && priceableValue > -1)
            pricelist = priceable.find(_ => _.id === priceableValue).object

        if (matchesMaxWidth1250)
            spanPricelistFilter = 1;

        for (let i in model) {
            if (model[i].class === "catalogName") {
                if (!matchesMaxWidth1100)
                    spanPrice++;
            }
            else if (["reference", "category"].includes(model[i].class)) {
                if (!matchesMaxWidth940)
                    spanPrice++;
            }
            else if (model[i].class === "price")
                break;
            else
                spanPrice++;
        }

        return <tr className={"priceable"}>
            <td colSpan={spanPrice} />
            <td colSpan={spanPricelistFilter} className={"pricelistFilter"} style={pricelist !== null ? {backgroundColor: pricelist.color + "22"} : {}}>
                <select value={priceableValue} onChange={changePriceable} style={pricelist !== null ? {color: pricelist.color} : {}}>
                    {
                        priceable.map((obj, index) => (
                            <option key={ index } value={ obj.id }>
                                {
                                    obj.value
                                }
                            </option>
                        ))
                    }
                </select>
            </td>
        </tr>
    }
    const changePriceable = event => {
        if (priceableChange === null) return
        priceableChange(event.currentTarget.value)
    }
    const resize = () => {
        setMatchesMaxWidth1250(window.matchMedia('(max-width: 1250px)').matches);
        setMatchesMaxWidth1100(window.matchMedia('(max-width: 1100px)').matches);
        setMatchesMaxWidth940(window.matchMedia('(max-width: 940px)').matches);
    }
    const displayFilterByAttribute = (attribute, index) => {
        switch (attribute) {
            case "inputs":
                if (filterValues.inputs !== undefined && filterValues.inputs !== null && filterValues.inputs.length > 0) {
                    const dictAttribute = {
                        "name": "Nom",
                        "lastname": "Nom",
                        "firstname": "Prénom",
                        "reference": "Référence",
                        "barcode": "Code barre",
                        "price": "Prix"
                    };
                    const dictConstraint = {
                        "begin": "Commence par",
                        "end": "Termine par",
                        "contains": "Contient",
                        "<": "Jusqu'à",
                        ">": "À partir de"
                    };

                    return <div key={index} className={"filtersList"}>
                        {
                            values.inputs.map((input, index2) => (
                                <div key={index2} className={"filter"}>
                                    <div className={"struct"}>
                                        <div className={"close"} onClick={() => { removeFilter(attribute, input); }}><CancelIcon /></div>
                                        <p className={"attribute"}>{ dictAttribute[input.attribute] }</p>
                                        <p className={"type"}>{ dictConstraint[input.constraint] }</p>
                                    </div>
                                    <p className={"value"}>{ buildValue(input) }</p>
                                </div>
                            ))
                        }
                    </div>
                }

                return;
            case "input":
                if (filterValues.input !== undefined && filterValues.input !== null && filterValues.input.length > 0) {
                    return <div key={index} className={"filter"}>
                        <div className={"struct"}>
                            <div className={"close"} onClick={() => { removeFilter(attribute); }}><CancelIcon /></div>
                            <p className={"type"}>Contient</p>
                        </div>
                        <p className={"value"}>{filterValues.input}</p>
                    </div>;
                }

                break;
            case "catalog_id":
                if (filterValues.catalog_id !== undefined && filterValues.catalog_id !== null && filters.catalogs.length > 1) {
                    const catalog = filters.catalogs.find(_ => _.id === filterValues.catalog_id);

                    if (catalog !== undefined) {
                        return <div key={index} className={"filter"}>
                            <div className={"struct"}>
                                { item !== "products" && <div className={"close"} onClick={() => { removeFilter(attribute); }}><CancelIcon /></div> }
                                <p className={"attribute"}>Catalogue</p>
                            </div>
                            <p className={"value"}>{catalog.name}</p>
                        </div>;
                    }
                }

                break;
            case "category_id":
                if (filterValues.category_type !== undefined && filterValues.category_id !== undefined && filterValues.category_type !== null && filterValues.category_id !== null) {
                    const category = filters.categories.find(_ => _.id === parseInt(filterValues.category_id) && _.type === filterValues.category_type);

                    if (category !== undefined) {
                        return <div key={index} className={"filter"}>
                            <div className={"struct"}>
                                <div className={"close"} onClick={() => { removeFilter(attribute); }}><CancelIcon /></div>
                                <p className={"attribute"}>{filterValues.category_type === "category" ? "Catégorie" : "Sous-catégorie"}</p>
                            </div>
                            <p className={"value"}>{category.name}</p>
                        </div>;
                    }
                }
                else if (filterValues.category_type === undefined && filterValues.category_id !== undefined && filterValues.category_id !== null) {
                    const category = filters.categories.find(_ => _.id === parseInt(filterValues.category_id));

                    if (category !== undefined) {
                        return <div key={index} className={"filter"}>
                            <div className={"struct"}>
                                <div className={"close"} onClick={() => { removeFilter(attribute); }}><CancelIcon /></div>
                                <p className={"attribute"}>Catégorie</p>
                            </div>
                            <p className={"value"}>{category.name}</p>
                        </div>;
                    }
                }

                break;
            case "vat_rate_id":
                if (filterValues.vat_rate_id !== undefined && filterValues.vat_rate_id !== null) {
                    const vatRate = filters.vatRates.find(_ => _.id === filterValues.vat_rate_id);

                    if (vatRate !== undefined) {
                        return <div key={index} className={"filter"}>
                            <div className={"struct"}>
                                <div className={"close"} onClick={() => { removeFilter(attribute); }}><CancelIcon /></div>
                                <p className={"attribute"}>TVA</p>
                            </div>
                            <p className={"value"}>{vatRate.name}</p>
                        </div>;
                    }
                }

                break;
            case "group_id":
                if (filterValues.group_id !== undefined && filterValues.group_id !== null && filters.sellerGroups.length > 1) {
                    const group = filters.sellerGroups.find(_ => _.id === filterValues.group_id);

                    if (group !== undefined) {
                        return <div key={index} className={"filter"}>
                            <div className={"struct"}>
                                <div className={"close"} onClick={() => { removeFilter(attribute); }}><CancelIcon /></div>
                                <p className={"attribute"}>Groupe</p>
                            </div>
                            <p className={"value"}>{group.name}</p>
                        </div>;
                    }
                }

                break;
            case "license_id":
                if (filterValues.license_id !== undefined && filterValues.license_id !== null && filters.licenses.length > 1) {
                    const license = filters.licenses.find(_ => _.id === filterValues.license_id);

                    if (license !== undefined) {
                        return <div key={index} className={"filter"}>
                            <div className={"struct"}>
                                <div className={"close"} onClick={() => { removeFilter(attribute); }}><CancelIcon /></div>
                                <p className={"attribute"}>Licence</p>
                            </div>
                            <p className={"value"}>{license.name}</p>
                        </div>;
                    }
                }

                break;
            case "interfaceType":
                if (filterValues.interfaceType !== undefined && filterValues.interfaceType !== null && filters.interfaceTypes.length > 1) {
                    const interfaceType = filters.interfaceTypes.find(_ => _.id === filterValues.interfaceType);

                    if (interfaceType !== undefined) {
                        return <div key={index} className={"filter"}>
                            <div className={"struct"}>
                                <div className={"close"} onClick={() => { removeFilter(attribute); }}><CancelIcon /></div>
                                <p className={"attribute"}>Interface</p>
                            </div>
                            <p className={"value"}>{interfaceType.name}</p>
                        </div>;
                    }
                }

                break;
            case "brand":
                if (filterValues.brand !== undefined && filterValues.brand !== null && filters.brands.length > 1) {
                    const brand = filters.brands.find(_ => _.id === filterValues.brand);

                    if (brand !== undefined) {
                        return <div key={index} className={"filter"}>
                            <div className={"struct"}>
                                <div className={"close"} onClick={() => { removeFilter(attribute); }}><CancelIcon /></div>
                                <p className={"attribute"}>Marque</p>
                            </div>
                            <p className={"value"}>{brand.name}</p>
                        </div>;
                    }
                }

                break;
            case "variablePrice":
                if (filterValues.variablePrice !== undefined && (filterValues.variablePrice === 1 || filterValues.variablePrice === 0)) {
                    return <div key={index} className={"filter"}>
                        <div className={"struct"}>
                            <div className={"close"} onClick={() => { removeFilter(attribute); }}><CancelIcon /></div>
                            <p className={"attribute"}>Prix variable</p>
                        </div>
                        <p className={"value"}>{(filterValues.variablePrice === 1 ? "Oui" : "Non")}</p>
                    </div>;
                }

                break;
            case "tags":


                break;
            default: break;
        }
    }
    const buildValue = input => {
        if (input.attribute === "price")
            return stringTools.number_format(input.value, 2, ",", " ") + (input.attribute === "price" ? " €" : "");
        else
            return input.value;
    }
    const removeFilter = (attribute, target) => {
        let newValues = Object.assign({}, values);

        switch (attribute) {
            case "inputs":
                let inputs = newValues.inputs.slice();
                const index = inputs.findIndex(_ => _.attribute === target.attribute && _.constraints === target.constraints && _.value === target.value);

                if (index >= 0)
                    inputs.splice(index, 1);

                newValues.inputs = inputs;
                break;
            case "input":
                newValues.input = null;
                break;
            case "catalog_id":
                newValues.catalog_id = null;
                break;
            case "category_id":
                newValues.category_id = null;
                newValues.category_type = null;
                break;
            case "vat_rate_id":
                newValues.vat_rate_id = null;
                break;
            case "group_id":
                newValues.group_id = null;
                break;
            case "license_id":
                newValues.license_id = null;
                break;
            case "brand":
                newValues.brand = null;
                break;
            case "interfaceType":
                newValues.interfaceType = null;
                break;
            case "variablePrice":
                newValues.variablePrice = null;
                break;
            case "tags":

                break;
            default: break;
        }

        validFilters(newValues);
    }

    useEffect(() => {
        window.addEventListener('resize', resize)
        return () => window.removeEventListener('resize', resize)
    }, []);
    useEffect(() => {
        setValues(filterValues);
    }, [filterValues]);
    useEffect(() => {
        if (pagination === null && list.length > 0)
            initMaxHeightTableBody()
    }, [pagination, list]);

    return (
        <div className={ "wrapList" + (noMarginTopWrapList ? " noMarginTop" : "") + (noBorder ? " noBorder" : "" )}>
            <div className={"pagination"}>
                <div className={"filtersPart"}>
                    <div className={"containerTotal"}>
                        <p className="nbTotal">{ pagination !== null ? pagination.total : list.length }<span>{ titleNbItems }</span></p>
                        {
                            (openFilters !== undefined && item !== "sales") && <button className={"filtersButton"} onClick={openFilters}><FiltersIcon /></button>
                        }
                    </div>
                    {
                        item !== "sales"
                        && <div className={"filtersList"}>
                            {
                                (filterValues !== null && filterValues !== undefined) &&
                                Object.keys(filterValues).map((attribute, index) => displayFilterByAttribute(attribute, index))
                            }
                        </div>
                    }
                </div>
                {
                    pagination !== null
                        ? <div className="index">
                            {
                                loading && <LoaderCircle display="loader restPagination" strokeWidth="10" />
                            }
                            <p className="nbItems" id="nbItems_top" onClick={ () => { handleShowOptionNbItems("top") } }>{ buildNbItems() }</p>
                            <OptionNbItems type="optionNbItems" show={ showOptionNbItems } handleClick={ handleChangePerPage } />
                            { buildButtonArrow("left") }
                            { buildButtonArrow("right") }
                        </div>
                        : loading && <LoaderCircle display="loader restPagination" strokeWidth="10" />
                }
            </div>
            <table className="list">
                <thead>
                    {
                        priceable !== null
                        && buildPriceableFilter()
                    }
                    <tr className="header">
                    {
                        checkable
                        && <th className="checkbox"><InputCheckbox name="all-selected" checked={ list.length > 0 && listChecked.length === list.length } handleChange={ handleCheckAll } /></th>
                    }
                    {
                        model.map((column, index) => buildThs(column, index))
                    }
                    {
                        openable
                        && <th className="access" />
                    }
                </tr>
                </thead>
                <tbody>
                    {
                        list.length > 0
                            ? list.map((obj, index) => (
                                <Line key={ index } obj={ obj } item={ item } model={ model } priceable={ priceable } priceableValue={ priceableValue } storeableValue={storeableValue} checkable={ checkable } openable={ openable } checked={ listChecked.includes(obj.id) } handleChecked={ handleCheckLine } />
                            ))
                            : <tr><td className="empty" colSpan={ calcColspan() }>{ loading ? "Chargement..." : emptyList }</td></tr>
                    }
                </tbody>
            </table>
            {
                pagination !== null
                && <div className="pagination borderTop">
                    <div className="index">
                        <p className="nbItems" id="nbItems_bottom" onClick={ () => {} }>{ buildNbItems() }</p>
                        { buildButtonArrow("left") }
                        { buildButtonArrow("right") }
                        {
                            loading && <LoaderCircle display="loader restPagination" strokeWidth="10" />
                        }
                    </div>
                </div>
            }
        </div>
    )
}

export default Table;